import React, { Fragment } from 'react';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { Accordion, AccordionContentContainer, AccordionHeaderContainer } from '../../../../accordion/accordion.js';
import { Text } from '../../../../text/text.js';
import './wizard-sidebar-group.css';
function WizardSidebarGroup(props) {
    const barGroupClassName = classNames({
        'c-wizard-sidebar-group': true,
        'c-wizard-sidebar-group--current': props.currentGroup,
        'c-wizard-sidebar-group--done': props.done || props.readOnly,
        'c-wizard-sidebar-group--read-only': props.readOnly,
        't-color-signal-green': true,
    });
    return (React.createElement(Fragment, null,
        React.createElement(Accordion, { className: barGroupClassName, initialCollapsed: !props.currentGroup },
            React.createElement("div", { className: "c-wizard-sidebar-group__header", slot: AccordionHeaderContainer.name },
                React.createElement("div", { className: "c-wizard-sidebar-group__header-index" }, props.displayIndex),
                React.createElement("div", { className: "c-wizard-sidebar-group__header-text" },
                    React.createElement(Text, { className: "c-wizard-sidebar-group__header-title", ellipsis: true, value: props.title }))),
            React.createElement("div", { className: "c-wizard-sidebar-group__content", slot: AccordionContentContainer.name },
                React.createElement("div", { className: "c-wizard-sidebar-step-group__separator" }),
                props.children)),
        props.showSeparator ? React.createElement("div", { className: "c-wizard-sidebar-group__separator" }) : null));
}
export { WizardSidebarGroup, };
//# sourceMappingURL=wizard-sidebar-group.js.map